<arm-layout [summaryTitle]="'USERS SUMMARY'">
    <div header>
        <div class="search-container">
            <arm-search (onSearch)="onSearch($event)"
                        [searchComponent]="usersSearchComponent"
                        [searchData]="searchData"
                        [searchTerms]="searchTerms">
            </arm-search>
        </div>

        <div class="action-buttons">
            <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                            (editClick)="editItem()" [disableEdit]="isUnauthorized || !isSingleSelection()"
                            (deleteClick)="removeItems()" [disableDelete]="isUnauthorized || !isAnySelection()"
                            (refreshClick)="refreshItems(true)"></arm-action-bar>

            <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button (click)="getNumberOfUsers()" mat-menu-item>
                    <span>Total Users Count</span>
                </button>

                <button (click)="exportToCSV()" mat-menu-item>
                    <span>Export</span>
                </button>

                <button (click)="openColumnsConfiguration()" mat-menu-item>
                    <span>Table columns</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div summary>
        <users-tab-summary [selection]="selection"
                           [userGroupIdToName]="userGroupIdToName">
        </users-tab-summary>
    </div>

    <div main>
        <arm-table [displayedColumns]="displayedColumns" [data]="data"
                   (onSelection)="onSelection($event)" [isMultipleSelection]="true"
                   [isCursorPageTable]="true"  [isPagedTable]="false"
                   [pageEventCursor]="pageEventCursor" (pageChangedCursor)="pageChanged($event)"
                   (sortChange)="sortChange($event)"></arm-table>
    </div>
</arm-layout>

